/**
 * @module:  沃客信未读消息
 * @author: Liang Huang
 * @date: 2019-08-22 10:07:54
 */
import { getSiteEnv } from '../utils/index';
import Cookies from 'js-cookie';
/**
 * 初始化未读消息socket实例
 * @param {InitUnreadSocketOptions} data 参数
 */

export function initUnreadSocket(data) {
  var usergroup_id = data.usergroup_id,
      options = data.options;
  initWebSocket(usergroup_id, options);
} // 最大连接数

var MAX_CONNECT_TIMES = 20;
var DEFAULT_DELAY = 10000;

var Socket =
/** @class */
function () {
  // tslint:disable-next-line: variable-name
  function Socket(url, usergroup_id, options) {
    if (options === void 0) {
      options = {};
    }

    this.options = {};
    this.leftCont = MAX_CONNECT_TIMES; // 是否是连接状态

    this.isConnect = false; // 当前socket实例

    this.socket = null; // 间隔心跳对象

    this.heartbeatInterval = null;
    this.url = url;
    this.token = Cookies.get('cwsso_token');
    this.usergroup_id = usergroup_id;
    this.options.reconnectDelay = options.reconnectDelay || DEFAULT_DELAY;

    if (this.token) {
      // 连接
      this.createConnect();
    }
  }

  Socket.prototype.createConnect = function () {
    var _this = this;

    if (this.leftCont <= 0) {
      setTimeout(function () {
        _this.leftCont = MAX_CONNECT_TIMES;

        _this.reConnect();
      }, this.options.reconnectDelay);
      return;
    }

    this.connect();
  }; // 初始化订阅


  Socket.prototype.subscription = function () {
    var _this = this;

    var params = {
      action: 'register',
      body: {
        event: 'event_unread_count',
        token: this.token,
        usergroup_id: this.usergroup_id
      }
    };
    this.sendMsg(params);
    this.heartbeat();
    this.heartbeatInterval = setInterval(function () {
      return _this.heartbeat();
    }, 30 * 1000);
  };

  Socket.prototype.connect = function () {
    var _this = this;

    this.socket = new WebSocket(this.url);

    this.socket.onopen = function () {
      _this.isConnect = true; // console.log('register');

      _this.subscription();
    };

    this.socket.onmessage = this.messageHander.bind(this);

    this.socket.onerror = function () {// console.log('socket error observed:', err);
    };

    this.socket.onclose = function (evt) {
      _this.isConnect = false;
      if (_this.heartbeatInterval) clearInterval(_this.heartbeatInterval);

      _this.reConnect(); // console.log('close', evt);
      // setTimeout(this.reConnect.bind(this), DELAY);

    };
  };

  Socket.prototype.reConnect = function () {
    --this.leftCont;
    this.createConnect();
  };

  Socket.prototype.sendMsg = function (data) {
    if (this.socket && this.isConnect) {
      try {
        this.socket.send(JSON.stringify(data));
      } catch (error) {
        console.log(error);
      }
    }
  };
  /**
   * 发送心跳包
   *
   * @memberof Socket
   */


  Socket.prototype.heartbeat = function () {
    this.sendMsg({
      action: 'keepalive',
      body: {
        content: 'ping'
      }
    });
  };
  /**
   * 接收消息
   *
   * @param {*} evt 消息体
   * @memberof Socket
   */


  Socket.prototype.messageHander = function (evt) {
    try {
      var data = JSON.parse(evt.data);
      var event_1 = data.event,
          type = data.type,
          usergroup_id = data.usergroup_id,
          user_id = data.user_id,
          createat = data.createat,
          unread_count = data.unread_count; // console.log('receive message', data);

      if (event_1 === 'event_unread_count') {
        // 处理未读消息的显示
        renderUnread(+unread_count);
      }
    } catch (error) {}
  };

  return Socket;
}();

function initWebSocket(usergroup_id, options) {
  var env = getSiteEnv();
  var url = {
    test: 'wss://yunxun.yunwoke.com/events',
    beta: 'wss://beta-yunxun.yunwoke.com/events',
    prod: 'wss://i.clouderwork.com/events'
  }; // const token = "283QH3LAqGd9sdYhx2j8X7KqPgumF37kVjD2WwvaTbDvQcWpX94RUfa9595UftPM:1565207032";

  new Socket(url[env], usergroup_id, options);
}
/**
 * 渲染未读消息dom
 * @param {*} num 未读消息数量
 */


function renderUnread(num) {
  var dom = document.querySelector('.menu-ykx');
  var unread = document.getElementById('wkx-unread-num');

  if (dom.contains(unread)) {
    unread.innerHTML = renderNum(num);
  } else {
    dom.appendChild(generateHTML(num));
  }
} // 生成样式


function generateStyle() {
  return "position: absolute;\n  right: 0;\n  top: 4px;\n  display: block;\n  background-color: #f00;\n  color: #fff;\n  font-size: 12px;\n  text-align: center;\n  border-radius: 10px;\n  white-space: nowrap;\n  padding: 0 6px;\n  overflow: hidden;\n  min-width: 20px;\n  font-weight: normal;\n  box-sizing: border-box;\n  ";
}

function renderNum(num) {
  if (num > 99) {
    return '99+';
  } else if (+num === 0) {
    return '';
  }

  return num.toString();
} // 生成html


function generateHTML(num) {
  var span = document.createElement('span');
  span.innerHTML = renderNum(num);
  span.id = 'wkx-unread-num';
  span.setAttribute('style', generateStyle());
  return span;
}